import React from "react";
import styled from "styled-components";
import garageIcon from "./garage.svg";

interface GarageHeaderProps {
    text: string;
    icon?: string;
}

export const Root = styled("h1")`
    color: ${(props) => props.theme.palette.grey[100]};
    font-size: 30px;
    font-weight: 500;
    margin: 0 0 19px 0;
    text-align: center;
`;

const Img = styled("img")`
    min-height: 35px;
`;

const Header = ({ text, icon }: GarageHeaderProps) => (
    <Root>
        <Img src={icon || garageIcon} />
        <br />
        {text}
    </Root>
);

export default Header;
